import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { useFeatureToggles } from '@grandvisionhq/state';
import { defaultComponentDefinitions } from '../component-definitions.js';
import { createConfiguration } from '../configuration/configuration.js';
import { initialValue, BloomreachContext } from './context.js';
import { getPageSeo } from '../utils/get-page-seo.js';

/**
 * This is in a separate module from BloomreachContext itself to avoid a
 * circular dependency between ../component-definitions and ../containers.
 * Do not re-export this from ./index
 */ function BloomreachProvider({ settings , children  }) {
    var ref3;
    const { apiUrl , customComponentMap , componentDefinitions =defaultComponentDefinitions , excludeSkuFromProductUrls , pageModel , visitor , path ,  } = settings;
    const { isMultilingualEnabled  } = useFeatureToggles();
    const sdkConfig = React.useMemo(()=>{
        return createConfiguration({
            apiUrl,
            path: path || '',
            options: {
                isMultilingual: isMultilingualEnabled,
                locale: settings.locale,
                visitor
            }
        });
    }, [
        apiUrl,
        isMultilingualEnabled,
        settings.locale,
        visitor,
        path
    ]);
    const siteLogos = React.useMemo(()=>{
        var ref;
        var ref2;
        const models = (ref2 = pageModel === null || pageModel === void 0 ? void 0 : (ref = pageModel.page) === null || ref === void 0 ? void 0 : ref.models) !== null && ref2 !== void 0 ? ref2 : {};
        var _logoUrl, _logoSmallUrl, _logoMobileUrl, _logoAlternativeUrl, _reimbursableLogoUrl, _reimbursableLogoAlternativeUrl, _payInstallmentsLogoUrl, _logoFooter;
        return {
            main: (_logoUrl = models.logoUrl) !== null && _logoUrl !== void 0 ? _logoUrl : '',
            small: (_logoSmallUrl = models.logoSmallUrl) !== null && _logoSmallUrl !== void 0 ? _logoSmallUrl : '',
            mobile: (_logoMobileUrl = models.logoMobileUrl) !== null && _logoMobileUrl !== void 0 ? _logoMobileUrl : '',
            alternative: (_logoAlternativeUrl = models.logoAlternativeUrl) !== null && _logoAlternativeUrl !== void 0 ? _logoAlternativeUrl : '',
            reimbursable: (_reimbursableLogoUrl = models.reimbursableLogoUrl) !== null && _reimbursableLogoUrl !== void 0 ? _reimbursableLogoUrl : '',
            reimbursableAlternative: (_reimbursableLogoAlternativeUrl = models.reimbursableLogoAlternativeUrl) !== null && _reimbursableLogoAlternativeUrl !== void 0 ? _reimbursableLogoAlternativeUrl : '',
            payInstallmentsLogo: (_payInstallmentsLogoUrl = models.payInstallmentsLogoUrl) !== null && _payInstallmentsLogoUrl !== void 0 ? _payInstallmentsLogoUrl : '',
            logoFooter: (_logoFooter = models.logoFooter) !== null && _logoFooter !== void 0 ? _logoFooter : ''
        };
    }, [
        pageModel
    ]);
    var ref1;
    const preview = (ref1 = pageModel === null || pageModel === void 0 ? void 0 : (ref3 = pageModel._meta) === null || ref3 === void 0 ? void 0 : ref3.preview) !== null && ref1 !== void 0 ? ref1 : false;
    const pageSeo = getPageSeo(pageModel);
    const value = React.useMemo(()=>swcHelpers.objectSpread({}, initialValue, {
            apiUrl,
            componentDefinitions,
            customComponentMap,
            excludeSkuFromProductUrls,
            pageModel,
            preview,
            path,
            siteLogos,
            sdkConfig,
            pageSeo,
            isMultilingualEnabled
        })
    , [
        apiUrl,
        componentDefinitions,
        customComponentMap,
        excludeSkuFromProductUrls,
        pageModel,
        preview,
        path,
        siteLogos,
        sdkConfig,
        pageSeo,
        isMultilingualEnabled, 
    ]);
    return /*#__PURE__*/ React.createElement(BloomreachContext.Provider, {
        value: value,
        children: children
    });
}

export { BloomreachProvider };
//# sourceMappingURL=Provider.js.map
